




































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Status } from "@/modules/simulator/store";
import OutputResults from "./components/OutputResults.vue";
import OutputVisualization from "./components/OutputVisualization.vue";

const { State, Action } = namespace("campos_novos/simulator");

@Component({
    components: {
        OutputResults,
        OutputVisualization
    }
})
export default class OutputData extends Vue {
    @State
    public readonly status!: Status;

    @State("is_valid_results")
    public readonly isValidResults!: boolean;

    @State
    public readonly started_at!: string | null;

    @State("time_elapsed")
    public readonly timeElapsed!: number;

    public get hasResults(): boolean {
        return this.status === Status.success;
    }

    public get startedAt(): string {
        const { started_at: startedAt } = this;

        if (!startedAt) {
            return "";
        }

        return startedAt;
    }
}
